<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QTfG1Y/tc-custom/9781644572771.jpg?1684229398125" alt="This image is the cover for the book Christmas Angels (A Mercy Allcutt Mystery, Book 7), Mercy Allcutt Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christmas Angels (A Mercy Allcutt Mystery, Book 7), Mercy Allcutt Mystery
      </h1>
      <p class="bookDescription body article font2">
        <b>A Saturday Christmas Shopping Trip to Chinatown Leads to Murder in <i>Christmas Angels,</i> a Historical Cozy Mystery from Alice Duncan</b><br/><br/><i>1926, Los Angeles, CA</i><br/><br/>Mercy and Lulu visit one of Ernie Templeton's favorite Chinatown dives, a silken items shop owned by Ernie's friend, Charley Wu.<br/><br/>Their Christmas shopping plans take a chill when they witness a young Chinese woman being dragged kicking and screaming into the shop by its proprietor. Even more chilling is the woman's plea for help as she passes Lulu and Mercy.<br/><br/>When the body of an elderly Chinese man is found in a nearby alley the next day, the police arrest Charley for the murder. Ernie Templeton, concerned about police hostilities toward the community, decides to investigate along with Mercy and Lulu.<br/><br/>But Chinatown doesn't welcome the prying of outsiders. Known for its seedy underbelly and dark secrets, those who ask questions often meet a bitter end.<br/><br/><b>Publisher Note:</b> Readers who enjoy cozy mysteries in historical settings are sure to appreciate the Mercy Allcutt series set in 1920s Los Angeles, California. No vulgarity or explicit sex for those who appreciate a clean and wholesome read.<br/><br/><b>The Mercy Allcutt Mystery Series</b><br/><i>Lost Among the Angels<br/>Angels Flight<br/>Fallen Angels<br/>Angels of Mercy<br/>Thanksgiving Angels<br/>Angels Adrift<br/>Christmas Angels</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alice Duncan
      </h2>
      
      <p class="authorDescription body article">Award-winning author Alice Duncan lives with a herd of wild dachshunds (enriched from time to time with fosterees from New Mexico Dachshund Rescue) in Roswell, New Mexico. She's not a UFO enthusiast; she's in Roswell because her mother's family settled there fifty years before the aliens crashed. Visit Alice at www.aliceduncan.net.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f4f2ca5